import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=5d2bf9af&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=5d2bf9af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2bf9af",
  null
  
)

export default component.exports